export default text => (text ? text.replace(/(^\w{1})|(\s{1}\w{1})|('{1}\w{1})/g, match => match.toUpperCase()) : '');
